const codes = [
    {
        title: 'curl (bash)',
        language: 'bash',
        code: `
curl \\
-F "file=@audio.ogg" \\ # Audio file
-H "Authorization: Bearer YOUR_API_KEY" \\ # API key
-X POST \\ # Type = POST
"https://api.connect-api.com/speech/transcribe" # Speech API endpoint
`
    },
    {
        title: 'node.js',
        language: 'javascript',
        code: `
const fs = require('fs');
const FormData = require('form-data');
const axios = require('axios');

const token = 'YOUR_API_KEY';
const url = \`https://api.connect-api.com/speech/transcribe\`;

const form = new FormData();
form.append('file', fs.createReadStream('audio.ogg'));

const { data } = await axios.post(url, form, {
    headers: {
        ...form.getHeaders(),
        'Authorization': \`Bearer \${token}\`
    }
});

console.log(data.text); // Transcribed text
console.log(data.duration); // Duration in minutes
`
    },
    {
        title: 'python',
        language: 'python',
        code: `
import requests

token = 'YOUR_API_KEY'
url = 'https://api.connect-api.com/speech/transcribe'

with open('audio.ogg', 'rb') as f:
    response = requests.post(
        url,
        files={'file': f},
        headers={'Authorization': f'Bearer {token}'}
    )

result = response.json()
print(result['text'])      # Transcribed text
print(result['duration'])  # Duration in minutes
`
    },
    {
        title: 'php',
        language: 'php',
        code: `
$token = 'YOUR_API_KEY';
$url = 'https://api.connect-api.com/speech/transcribe';

$ch = curl_init($url);
curl_setopt($ch, CURLOPT_POST, true);
curl_setopt($ch, CURLOPT_POSTFIELDS, [
    'file' => new CURLFile('audio.ogg')
]);
curl_setopt($ch, CURLOPT_HTTPHEADER, [
    'Authorization: Bearer ' . $token
]);
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);

$result = json_decode(curl_exec($ch), true);
echo $result['text'];     // Transcribed text
echo $result['duration']; // Duration in minutes
`
    }
];

export default codes;
